import { Role } from '../models/user';

export function filterRolesForClient(roles: Role[], isClient: boolean): Role[] {
  if (!isClient) return roles;
  return roles.filter(r => r.Name === 'Customer');
}

export function shouldSkipClientStep(clientCount: number, isClient: boolean): boolean {
  return isClient && clientCount === 1;
}
